export default __webpack_public_path__ + "static/media/Calculator.a894a57e.svg";